var _rect, _path, _path2, _text, _rect2, _path3, _path4, _text2, _path5, _path6, _path7, _text3, _path8, _path9, _text4, _path10, _path11, _text5, _path12, _path13, _text6, _path14, _path15, _text7, _rect3, _text8, _path16, _path17, _text9, _path18, _path19, _text10, _path20, _path21, _text11, _image, _rect4, _text12, _path22, _path23, _text13, _path24, _path25, _text14, _switch;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmplifyArch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "862px",
    height: "432px",
    viewBox: "-0.5 -0.5 862 432",
    content: "<mxfile host=\"Electron\" modified=\"2022-03-17T05:42:50.322Z\" agent=\"5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) draw.io/16.5.1 Chrome/96.0.4664.110 Electron/16.0.7 Safari/537.36\" etag=\"Po0yYDFDWRHzc5RG5HJr\" version=\"16.5.1\" type=\"device\"><diagram id=\"NsRZ7qbhegtvqmY4NJTg\" name=\"Page-1\">7VxZm5u40v41uZx52JdLdrCNjQEbm5t5MJsx+778+k/qdifpdmeSOVnmzHyn00lQSSpEqeqtVxL2B1zIJ6XxqqteBmH2AUOC6QMufsAwFCFx8B+UzM8SlkSeBXGTBPdGnwRWsoQvPe/SPgnC9lXDriyzLqleC/2yKEK/eyXzmqYcXzeLyuz1XSsvDh8Elu9lj1InCbrrs5TB6E9yNUzi68udUYp9rsm9l8b3J2mvXlCOn4lw6QMuNGXZPV/lkxBm0HgvdnnuJ3+h9uPAmrDovqXD7g9qFH+jsuuStUbSIb21YX57UTN4WX9/4vtou/nFBE3ZF0EItSAfcH68Jl1oVZ4Pa0cw6UB27fIMlFBweVcXNl04fXGg6MfHB34TlnnYNTNocu9A3w02frI3Rt1l189s/VHo3ec4/qjqkxnAxd0Sf8Eqj0bhHAsIhKzsgwf7VGVSdE9DIHnwCwYlIB9IUCPA0u8Y+Ubwtky/FqCPJajjteBtmX4tQN+qR9/cH307wM8ED6VX6pE390c+GyD4xfmy77KkCIWPAQm9Jm68IAHzL5RZ2QBZURbha8d5z6+isujukIBiL+W74aFWEPSdB+7V3HU8zUTYSEP4PCHPbbLMq9rk8rFXE/p90yZDaIbts3IoBeFZwet8iiGS/e6NLfF7DHy/ehq+Bu71bu0f4PIPHzrGH17WQUVdU6bhy4N+wHDwR4bOx0dJlr0xAAyUBKANlyUx1N+V8HbevZSF0ZNGYJWkiDdPJRFH7pZ47xaB114/huoPiEUCeQxGEn8nGAn8ZwUjTv1giPpoI/T9Ofkms30ZN75oS/Qlp91TIYazD7Yl0HdsizI/y7b0l4CujIukKx/s3KZh51/vZn4X997Fvvfw710MfMTBV82ekOmdO7wVviejH4XoY7MXMHsUvid7D7nf9kbf6Y2+6f1l3PxSnL/FU1AnkwRNsJ/ViQlAui55wq2ibKCLvXJ30EegURyV3wOt6OnnLaK8wNXGu4SZUbbJXf2l7Loy/yqe+SGE59fR+DWM99rq2RxRMsFxvA/UTdiWfeOHzzANIL59D7D9u1v/vBgnXoc4+YieNPMY4C+yHx7fLzT1sxAOA8Bv70XoFGVcFl4mfZLyr8H0U5tNCSfzadJuYdfN91nz+ieLfjalwIDNfPq8cIbKQBDci+J0V/5cmj8vGWGTgId/yulPebnzmo6DTB46UOa1beK/iOUke8074cP9B9MJDPTkPX9myfs6Btw2Dv9MIf2+fzRh5nWAc7xeoLwz309dwfN682cN7lD7SbMBBZ/cDkNe+x3DvnGdZ4WfHOnjyL7Dt5iH5EH8DnPHNfRTQFfe9bwn4HjtLQ/g8BZD8iQInh0T8jXvE5F7nYDEPwvr+/Lw3vnTouyr/oF9YT7v6n+DeM+8sv1vd3ry12b805S+NCmjqAWe9hYCfsTMsX8rKiA/GhXuvO1zSED+myABI74TE76PPyMPcUrCODXDug9b4GCUl8MkXVza6qPV/vFhy34tbFGKwV/FLfp9YXvXzLyn8xeENP7I5A0NCBSvC0dv/h+T/wcxeZYgRRn7a0ye5HCEJ//fMHmvSv6I7679E1fs9JsVO/s383kcfQjkX5G5p6T7mLjB9XPepsl78VPehoX5s8LbrP2lhQH9z+UAxLdyAPxv5QDYQ3qgnjlAW5VFG/47kj7+59GM/I5jFP1DsvzLtL/gwi9L88TDPG68/BJ4QBb1xVOOaP+X6/9BuV6mGQkh/lquFxFSQOn/N7k+e/bwn5fmcfa/Lc1/aV/eChvw+FnYgiBHuMaHBx1+3zWPAA5M1P087IYc4X52hj744T0V/8KTFZx8M4Ho48nKRy736gj5Zx2sQDj59UTtWxjRD92G+cgMf38hg+fPOOP7xPAbKNk3sy/kV7Gv92nAb2+P9D462YuO50e4d/v85Yw3mkjqtSL8ZY/uRdHzIz4o+qsbxeh9Z/jtfX7uTvHjCS7+agfq30A+nyP+z3acEIx9veP0G/59ZPTn883HiXvOQ1xeZUn0v12lfxTT/N/58Fd3le5u/UNenUHfkJK/+ywY/VsoyS8/9XmhJC8k5LPb/aW9qh9IU6hvZCl/z9Ex9frI4vXR8Vebs8ifNv/4Wth/1vxXnGOjj0kOhezk0AJfAKmuB9H6r2Ao6FcZCoa8ISg/5kyMoN/V+gu2yx6PPh8pyz1dJPnTm+BfT2EZrOA9P42fwPElJwZh5PVPL4B+Ice9zVNPN+RepMiLBKryOu8Dzj0XMbmC71IIyZHfmSOyVuKSAz9b63CVDjG4MiTwj2gKnA7lde/tt/DCyXj9KJ2gTZ9+2Ss2dCYwvdx5WNRVuDGAKZMN8BcEgDzAG33A+IiWGQMHs8EPNP0s51l6QFnCWHgowGMQkzJtMbAjShvYFbiVPGvEsLhsRLXUgFmkMWOg5kIOc0oZy5YZyBmPeo4w5g0xzEcymvHLgezAMHfIIZP2R5ModsfAc/tE50ZHiNfrUtBC0BcOgc4Fq9Ixw87y05YAIwbBwS/6WcG9rRzarVxuzULpSyAVtuAfTD6JPGNq2zSgwTPJPKiRS4bu+TBZM60rLOV4jM9on+WFrtq761512aAtNhIrBf4154UzttZ9Q72Q+62NxUSAGvpGNy5KQam4sWaTgSdmBtuHXhuFt0MoKIFJ1ORghdj2iOtgCOsm7cbd2SbT7QUz+aByA3sfRYqHGf2tuhz8XdRLiEu57uCA2eV3e5bRu83lZo/0fFG33aYJejHfhst2XvIo7sPjyQVkhe1E94KEuTxiGpFfBSq+MZq2uqzMGYbPwnsFm8zbpKAxZ4h13jrIUe9mksbLwbiW+8ulbHSyLVZwusl96U3rzd7dKdB0+w2c334+k6tt6+NmUtrHSjSTUcrlAJl21jHN5KRCNouBIGzDZek0myPouQWz47gIb/Ur6E5D2aZlu/U3WJZQe2tp14oCp4CfGOSG5Jy0qrK8mVPHUwLdLeojAYaimrY0r9RUcup5JC/6JrvURSqeu0Go1EFqjHV/ZYnWi9yg57NtnBAZSyLi5CTXWicvptH5hczPemBMC4Es26rmVm1i0KuWEb3Nmk+DRDurB9fgLqJgGPRcuUxsjZgxpSF/Ome2z+vRzq3b2jWNvR7ciFEF/YtrPgvWShnSK5fli67V/JmlDyGnLZ2tTykbCGzro/3N6CLxVBIY3oXsyTc9jM/YwmWm4QocYgwYKTdPnhAAK5w30Bv99VBo9bpoUkW5Lt7GMGpaNtgbpRqo0Hq6ynt0fG71Z2fXViSIOt4whEWS44BFCXXERkTdAWGb04WgmC3adtnpOgVc0IfayTZHdx2VU2BkbpxHqN/sN8MO31n7aIxFOGte3gpsol8qf1ExPkgdCBIJcbUtDw7QsBOKDqfcwCbQmJI16mwCecjV8Q4ChdwZF02eDrsx6sS63tt9zNDBTh+rZkmZQspUJbf2QGIbqCEDAsITasPvMS+V9fwKUUWDT2bnbDisLPuGrvPQ3ptsNe8B6PGpfhnHA687aQ9dyjWzgkFVHXjkpkYrScv4VgLNTgc7N+o1deNPtLOTdMUk56sos0S4n8FaaS3FclEETcGY01E7FAUg+M8WhSMQYotWMhHSClpWMxZN97A2LWY3nKqdw4Ea025N2VpCKyTPIiIRNzfIy/ECatYOsBMf14JD6fiOPuNEAsrmYTNtj8hed9VkTVz5ckQN/8iAUOn2pHmUFHJydBudIC5d0GAb6WpD2xk3BEe5UdYZhh7lBQ6C9g3cs7coNwxwPvCzt+ZLgvZgZRxBXJ8TEbuKNDRlhLfHrhs9Y1KTcptGhGmy67zUzYoetOteMRUlaiOJ3FcVbzmrklyrcW+fYyauVH7PHHbIPiqNhN9eRcsZwRpFnGWjgAhvhcEVZKd47G5efPS1sIsNZT8DB5JdaLihRdFQ2Yo2XrveCekO+lTGCGdNhrSWo2sbrUv6FGsRTjLJZgccpRoRonbMWjuXJmakAKozVyX2PLFrVvTtfFxnyHye3JyJvNopWcbsHam98a2ahmoue+RBLi5mOHQ6qir7nZSupi2RyIeLX2jM3KVcxh7UkyDRK68od7w7D9mBsg8QfUZ6YccQCZhZqTUrkw/HU7YJ8K5LQa2P4SwGXc10jtnRHLXDhKNZCJ/R8p1sas3Ap0Yq5ZtpqoQQHQjHuG5vuiRGOmx0jp0daZRz3SCBmGJ753pkLOG2WCCPVoHtJKnE2+wJQYfjZl9lhBD2QRfcWL3O2Bl4uYGvizNMBCiFaqGoLIS22uByL/sXhyXX9Rx7yqFDYWLeHUNWAR7IB86J42eQWwxVJnexm0i+UXq7dHerw3l16XFrxrsslDiq2F74yWhrsmrl2DM2EUuKYNXCH663gkDPlgodGnA/Oav31LxJk4ti6z5h9x2PTBbCeMKkNsNqzfZWFOp9iZKOOYRkrRTzUzjJ6lTLLaO2AY3fbLNHbH0/c4zBRu2KNffzIe+pRnHR27lLZjOk0CVa7GqXDGuMmaD5bxJlSzwWKVM3g3HwpQ2UAmxSYjSYbg4mNHRAXVRgaR4/4+ho4ceI3EaHeqMYt31T+Qrwn4SKBsU81bWCufx2HIblGh68xDyNS4jBMGkOMMM1grwHUQkZT56l9Xit6dmF8Dr7A2Pn59knp3kgcB73glu4opVTQJ1yHhNuxRq0Us576XQu2W1rt0jpKXuYdwlAh3g3Lve+pQl5aluskzZ74WSRDcy0ZVJae8ErMbVHt5nPHHCJio6gZruXQsFOQ+nad+pyjsmobne3WKc3nb/DYzkHaq2FWItMJuXZLeHMwsuJhYzy4wYkbdnGIB1ySokYzFjjLhJDYaUrypy1EguOgHm9oeqqVlpNYCmnV6oVW1TNUIUk2Xu21qsCJH1VIOSnZrtfH+3gCWC2WiNMLb5JeOYwBAJVn5Nxz/mlh2NB724ttNzGo+YncqBeR0RRLlp6Lfqm5zSdMbaJ3I0yDLmSDXFL9HNNn7p+xSn7BSa0frXbFEJh83UYlQEhE2UXPaMyeojjYenZRDb0XL4cVDLbQK6HRRl5qvoGs7fc5qysbXEUOIrk1WE/5tygLxAPqViffLMVKWHV6VynnX0m4vhQQdTxDHiE2vGSuEBMrw9o5w5nK08M15vj805jjpncB5HaWjJYCbRVYIW7KxZL8s1MZ2Fbrc72LfBGeRx8jvISGUfZgaA5izVD1wqyvPYytCdUjM2i7jhrpumZVodsAu2wOnepgizujeOQA94wPFpp1HFOyS2k9pt87Rt+ttmp/K0YwpPiBUpHomcGTkKT1bbI21tjV8aHMrlgKx1dUZKQ79bL2CnXg70HuCaTrAlRoXJiQs9Xok6eHEk9EwuHh6uMO27II6Nn1SU72QBmZH6ZQ9vms35x8/ScaKWj1icJotz+FjW79lCF1DJz4g2S2Ju6poRpe6DD9tj6GiVI50NwUFCz2sYAqleiod2wFOFWe0VP+o08V2S4WW+wC2coPcUdWzCJ0hqmOg7NknIilKx1EkLYnYW5gAEnmryCeGCtt0zrvWI4DLLL/M36osoCLw85yJoxrTblysuvtom5h5hCxr2x3vh9e0L3p3VTohTPX2Q6LgjFBJwATT15q7pFxYvuga8d6TIKw34LiOnecwv2KvOE3kAfmFYGWtSCHKbRWW7Ggb0sMYO4zMbcG/VVFEQro9b8gTsq8hrHdIKbq7RxLqWk7+R574bmiatUvbFmqVyViKHRSJfojLk98f02cMfFF/k4jOTGL05HlwDJo27palduV66E59ZRolQuq/aDoak66hXbis9NEpUi16A4KaMhqp78bVFIGHFIDwifoRuI+Eyy7JJVZrk2ruKHcMVZh6EujJaniyNFTPbZbsldYyXWvBrnePCr1FgoDV8cwz1Lxgqsp3Y7Me28qxpvxPQGCYx61JvNKoIopo0hLjcdRt0w6BGrFWSXWyGxLRUtXPCw12q6OoyRZVQk+ZCBLE67MUXs4MXdqjnUlq1kSiRB0KIhgKerEq4fjxbOScKmUDwrZ5FJvNrVjAv2AJkwf+gPuiBfSVGLsFim5sY+yZUog0WRHGv2JNlWbO7FCklNaso0PbDK6CaPuiUQg4iG+C0Li3oMjyZra6DLyEaXkYED6GlaaYoUic6oa9B2dVZDm46EqFFvQ3Y6wRwTbRZOifuVbw90URDsMjqcRAInn3Gr0qwNToPUJMt6Il/nDemeNqNXTFHDrenaLrVZLnCAaWIDMzG60ta1ZM94j+c5HxBd5Kssk+ZIIdobEEtypM5+vFfIs8LcVtkwjzt3xUYFWwVzZHrnBTllNHewyXAJkK6Tdqd2FoJmcI5TSKa1GSJtpeAa/bRmx4PmBH1418Ag6shM9jfCfS2/LY8QR/UMIioLMbWC+ZWPBJxq6tV2DM/o5SQbDnJifYE2LFTs4PYAFrKHsdvaQX+FK2YdvYRH/hQYOUoHjXdyNpsLNW+rQ49fVAXpawNyJcgQC7NZ5mlEyQSZ84UQkIvJ8krdGLF226bXwIE5UxMHmt3LgNDvy+ftiBz+n3JU0DfR1udECHjBOtzAPJ3AHYbcgnsQNcOsAmrLnioSwMqpEbcUGXs+fXIdjDO6/oRi7pZa208sGKXWpijEtBtUjU0E1glHZxYqPsMkrA/s3g5cAu/IgcavkPE4AWThZHTAgPXBpdeSNsyHmWkUhyiM2wWDKL0lOvKMN62SDT4cXuiwOmEa0VwM11C2RtZd4mNDCnDYbEsv+A7BQRqBAZIKPSDaaaT6HW2zrQbHublBpekRXq8u+NA6YNUhB7sF6N2SR8NPimEajriDczuDaSAt64wB5nk36lweP8G5HozwsglRH/IWoTmVLeGYGuZlOOlGIy6v5/yCHQ/DEPGyDFmAFF9jJ3RxcUOtiM6/VJarFusNK7QBe1rtVzAgWHwUUZLgxwWZvKNzOhG7y3Bu5PJq1KuknIvjIG4EDwVNL0nprI3c8w5CuIZZaNgrHTWwu2FHjNsOd0q08hm82o2YZlzBkqBH1sebyGg3yAuIraQyExLzjYczHAxWhqJZUBfu1GFOWT7IQ0Wx62lC8BNz4dBN1Xg8zl80IT7uUoyTL61+0XcDNl4xZXtk55hlt1XFtYh4LCyDS3p1n9R71+MdOg5bOZx2q0S7eowj3sByO0fkcaEV92DLWw/LLMJlr+T5gvTDBGHrnFcLeVtrHrqnPcscdOSUXP1+WjknDavV2jsVwjXN4kuXEZujywn02MjQM1RzuklcspCb/RWklcEQz7XTsDcPPR0cPADrrttNrUNMm7e73e2snM2D30Nc129mIF+5VdsgbOpvFDVyDDo9pcOl5IpwyiASu7QCUGPYpmt/7QiXEt3UDs7sTOSqhHYyMsqu6QWGjdudKXVnw3dJL28qNYw8t+qKtVn4mBNzK4/rL0dDGXnCRS5Gs1qth6pw1GSRTzKWl9dUOYSe6cz4LlXsJK2IMoinZQCrDGue+GwWe02Xl/VOxyUBxTcavXZSYnbhLup6faYW0jkzrtaqWpRZZ7AWW/r5LA5Wi7U43JurmFh1sFViJKbF0kQp0z1LzRI2TYcg65p6/8Q8hJoNMjvpwZJ38ao4nBbI/GfO9NaVGS/k8YLromXGaG9iS4cokTxb49H3a1kB66SVumLPhHrGI3F76i6MWtS5d7N2S25mC0ytYgVIRt0kwhIKgeJ24xYkIKZJbw6P7zqY2bgNL+v1cS3iVNsRbXC1bI1f9QdGPTQwa857HNuz2nFbdMd6ZE6YzfDnduNRK/t4xhOtvRxTS0ZPy0wt0k5r9tO2ycfi0JHKfAhWntotdK3NGpEtML57g235HifFwVVDKgILecrQtGekhEjvug0aM1wXunDHl+NX5oGUmnQVxzHcxcb/9MDgLxxZEujvNPZqsx6lHo8tWeJ3kno8uWSwLx8MfN/LVI9vL5uh58MTBrl8OmiQiuBhY//xDbhvfU3t249x3vumgddHpj9gVt75PhT05fOen9v/530DA/G3nBz/8E8dPL178dkp9Mfz6S+cQf+gDxj8+M8TIu/7y3e/zfbm9BUlydc6ftRLaBT56j448QuOeXHyAUTof+FHIL7wUdPPPvfIvHkF8HsPeX/+MS7O/Dvw57/pU0/fCkr0N2IS9Z2Q9H0Jin2Ibez3j+9uIDbI+sW/JL6Zr8c3+v7rFt+ZHejvf2kD7r1//Lq75+afvjQQl/4P</diagram></mxfile>",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "0%",
    y2: "0%",
    id: "mx-gradient-f54749-1-c7131f-1-s-0"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(199, 19, 31)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(245, 71, 73)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "0%",
    y2: "0%",
    id: "mx-gradient-945df2-1-5a30b5-1-s-0"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(90, 48, 181)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(148, 93, 242)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "0%",
    y2: "0%",
    id: "mx-gradient-f78e04-1-d05c17-1-s-0"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(208, 92, 23)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(247, 142, 4)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 260,
    height: 260,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 330 0 L 860 0 L 860 430 L 330 430 Z",
    fill: "none",
    stroke: "#232f3e",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 336.09 7.18 C 336.01 7.18 335.93 7.19 335.85 7.19 C 335.5 7.19 335.15 7.23 334.81 7.32 C 334.53 7.39 334.25 7.49 333.98 7.62 C 333.9 7.65 333.84 7.7 333.79 7.76 C 333.75 7.83 333.74 7.91 333.74 7.99 L 333.74 8.32 C 333.74 8.46 333.79 8.53 333.88 8.53 L 333.99 8.53 L 334.22 8.44 C 334.45 8.35 334.69 8.27 334.94 8.21 C 335.17 8.16 335.41 8.13 335.65 8.13 C 336.04 8.09 336.43 8.2 336.74 8.44 C 336.97 8.74 337.09 9.12 337.05 9.5 L 337.05 9.99 C 336.79 9.93 336.54 9.88 336.29 9.84 C 336.05 9.81 335.81 9.79 335.57 9.79 C 334.98 9.76 334.4 9.94 333.94 10.31 C 333.54 10.65 333.32 11.15 333.34 11.68 C 333.31 12.15 333.49 12.62 333.82 12.96 C 334.18 13.29 334.66 13.46 335.15 13.44 C 335.91 13.45 336.63 13.11 337.11 12.51 C 337.18 12.66 337.24 12.79 337.31 12.91 C 337.38 13.02 337.46 13.12 337.55 13.21 C 337.6 13.27 337.67 13.31 337.75 13.31 C 337.81 13.31 337.87 13.29 337.92 13.25 L 338.34 12.97 C 338.41 12.93 338.46 12.86 338.47 12.77 C 338.47 12.72 338.45 12.67 338.42 12.62 C 338.34 12.47 338.26 12.31 338.21 12.14 C 338.15 11.95 338.12 11.75 338.13 11.55 L 338.14 9.37 C 338.2 8.77 338 8.18 337.59 7.74 C 337.17 7.39 336.64 7.19 336.09 7.18 Z M 349.89 7.19 C 349.78 7.19 349.68 7.19 349.57 7.2 C 349.29 7.2 349 7.24 348.73 7.31 C 348.47 7.38 348.23 7.5 348.01 7.66 C 347.82 7.81 347.66 7.99 347.54 8.21 C 347.42 8.43 347.35 8.67 347.36 8.92 C 347.36 9.27 347.48 9.61 347.69 9.89 C 347.97 10.22 348.34 10.46 348.76 10.56 L 349.72 10.87 C 349.97 10.93 350.2 11.05 350.39 11.22 C 350.51 11.35 350.58 11.51 350.57 11.69 C 350.58 11.94 350.45 12.18 350.23 12.31 C 349.93 12.48 349.6 12.56 349.26 12.54 C 348.99 12.54 348.72 12.51 348.46 12.45 C 348.22 12.4 347.98 12.32 347.75 12.22 L 347.58 12.15 C 347.54 12.14 347.5 12.14 347.46 12.15 C 347.36 12.15 347.31 12.22 347.31 12.36 L 347.31 12.69 C 347.31 12.76 347.32 12.82 347.35 12.89 C 347.4 12.97 347.47 13.03 347.56 13.07 C 347.8 13.19 348.06 13.28 348.32 13.34 C 348.66 13.41 349 13.45 349.35 13.45 L 349.33 13.46 C 349.66 13.45 349.98 13.4 350.29 13.3 C 350.55 13.22 350.8 13.09 351.01 12.92 C 351.21 12.77 351.38 12.57 351.49 12.34 C 351.61 12.1 351.67 11.83 351.66 11.56 C 351.67 11.23 351.56 10.9 351.36 10.63 C 351.09 10.32 350.73 10.09 350.33 9.99 L 349.39 9.69 C 349.13 9.61 348.88 9.49 348.67 9.32 C 348.54 9.2 348.47 9.03 348.47 8.85 C 348.46 8.61 348.58 8.38 348.79 8.25 C 349.06 8.11 349.36 8.05 349.67 8.06 C 350.11 8.06 350.55 8.14 350.96 8.32 C 351.04 8.37 351.12 8.4 351.21 8.41 C 351.31 8.41 351.36 8.34 351.36 8.19 L 351.36 7.88 C 351.37 7.8 351.35 7.72 351.31 7.66 C 351.25 7.59 351.18 7.54 351.11 7.49 L 350.83 7.38 L 350.45 7.27 L 350.01 7.2 C 349.97 7.2 349.93 7.19 349.89 7.19 Z M 346.02 7.36 C 345.94 7.35 345.86 7.38 345.79 7.42 C 345.72 7.5 345.68 7.59 345.66 7.69 L 344.51 12.14 L 343.47 7.71 C 343.45 7.61 343.41 7.52 343.34 7.44 C 343.26 7.39 343.17 7.37 343.07 7.38 L 342.54 7.38 C 342.44 7.37 342.35 7.39 342.27 7.44 C 342.2 7.51 342.15 7.61 342.14 7.71 L 341.09 12.14 L 339.97 7.7 C 339.95 7.6 339.91 7.51 339.84 7.44 C 339.76 7.39 339.67 7.36 339.58 7.37 L 338.92 7.37 C 338.81 7.37 338.76 7.43 338.76 7.54 C 338.77 7.63 338.79 7.72 338.82 7.81 L 340.38 12.95 C 340.4 13.05 340.45 13.14 340.52 13.21 C 340.6 13.26 340.69 13.29 340.78 13.28 L 341.36 13.26 C 341.46 13.27 341.55 13.25 341.63 13.19 C 341.7 13.12 341.74 13.03 341.76 12.93 L 342.79 8.64 L 343.82 12.93 C 343.83 13.03 343.88 13.12 343.95 13.19 C 344.03 13.25 344.12 13.27 344.21 13.26 L 344.79 13.26 C 344.88 13.27 344.97 13.25 345.04 13.2 C 345.11 13.13 345.16 13.03 345.18 12.94 L 346.79 7.79 C 346.84 7.72 346.84 7.63 346.84 7.63 C 346.84 7.59 346.84 7.56 346.84 7.52 C 346.84 7.48 346.82 7.43 346.79 7.4 C 346.76 7.37 346.72 7.35 346.67 7.36 L 346.05 7.36 C 346.04 7.36 346.03 7.36 346.02 7.36 Z M 335.65 10.62 C 335.7 10.62 335.75 10.62 335.8 10.62 L 336.43 10.62 C 336.64 10.64 336.85 10.67 337.06 10.71 L 337.06 11.01 C 337.07 11.21 337.05 11.4 337 11.59 C 336.96 11.75 336.88 11.9 336.77 12.01 C 336.61 12.21 336.39 12.36 336.14 12.44 C 335.91 12.52 335.67 12.56 335.43 12.56 C 335.18 12.6 334.93 12.53 334.73 12.37 C 334.55 12.18 334.46 11.92 334.49 11.66 C 334.47 11.36 334.59 11.08 334.81 10.89 C 335.06 10.72 335.35 10.62 335.65 10.62 Z M 351.04 14.72 C 350.34 14.73 349.51 14.89 348.88 15.33 C 348.69 15.46 348.72 15.63 348.94 15.63 C 349.64 15.54 351.21 15.35 351.5 15.71 C 351.78 16.06 351.19 17.54 350.94 18.21 C 350.86 18.41 351.04 18.49 351.21 18.34 C 352.39 17.36 352.72 15.3 352.46 15 C 352.32 14.85 351.74 14.71 351.04 14.72 Z M 332.65 15.1 C 332.5 15.12 332.42 15.3 332.58 15.44 C 335.29 17.89 338.82 19.23 342.48 19.21 C 345.37 19.22 348.2 18.36 350.59 16.74 C 350.95 16.47 350.63 16.07 350.26 16.23 C 347.87 17.24 345.3 17.76 342.71 17.77 C 339.23 17.78 335.82 16.87 332.81 15.14 C 332.75 15.11 332.69 15.1 332.65 15.1 Z M 330 0 L 355 0 L 355 25 L 330 25 Z",
    fill: "#232f3e",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe flex-start",
      width: 498,
      height: 1,
      paddingTop: 7,
      marginLeft: 362
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #232F3E; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(35, 47, 62)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "AWS Cloud")))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 362,
    y: 19,
    fill: "#232F3E",
    fontFamily: "Helvetica",
    fontSize: "12px"
  }, "AWS Cloud")))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 239,
    width: 410,
    height: 180,
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeDasharray: "3 3",
    pointerEvents: "all"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 370 50 L 448 50 L 448 128 L 370 128 Z",
    fill: "url(#mx-gradient-f54749-1-c7131f-1-s-0)",
    stroke: "none",
    pointerEvents: "all"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 383.31 84.34 L 397.64 84.34 L 397.64 82.14 L 383.31 82.14 Z M 432.63 100.36 L 434.19 101.92 L 426 110.09 C 425.79 110.31 425.51 110.41 425.22 110.41 C 424.94 110.41 424.66 110.31 424.45 110.09 L 420.33 105.98 L 421.89 104.42 L 425.22 107.76 Z M 437.7 106.43 C 437.45 108.5 436.61 110.42 435.26 112 C 434.31 113.12 433.1 114.04 431.77 114.67 C 429.99 115.51 428.02 115.83 426.05 115.59 C 424.13 115.36 422.33 114.61 420.82 113.41 C 417.93 111.12 416.47 107.56 416.91 103.89 C 417.33 100.42 419.43 97.4 422.53 95.8 C 424.01 95.04 425.64 94.65 427.29 94.65 C 427.72 94.65 428.15 94.67 428.57 94.72 C 432.03 95.15 435.05 97.26 436.64 100.37 C 437.59 102.24 437.96 104.34 437.7 106.43 Z M 438.6 99.38 C 436.68 95.61 433.03 93.05 428.84 92.54 C 426.31 92.23 423.78 92.68 421.52 93.85 C 417.77 95.78 415.23 99.44 414.73 103.63 C 414.19 108.06 415.95 112.36 419.45 115.14 C 421.27 116.58 423.46 117.5 425.78 117.78 C 426.29 117.84 426.81 117.87 427.32 117.87 C 429.18 117.87 431.03 117.46 432.72 116.66 C 434.33 115.9 435.79 114.78 436.94 113.43 C 438.57 111.52 439.59 109.19 439.89 106.69 C 440.2 104.17 439.75 101.64 438.6 99.38 Z M 394.34 90.95 L 398.75 90.95 L 398.75 88.75 L 394.34 88.75 Z M 383.31 90.95 L 392.13 90.95 L 392.13 88.75 L 383.31 88.75 Z M 382.36 62.33 L 431.67 62.33 C 432.97 62.33 434.02 63.61 434.02 65.19 L 434.02 73.34 L 430.72 73.34 L 430.72 67.83 C 430.72 67.23 430.22 66.73 429.61 66.73 L 404.26 66.73 C 403.65 66.73 403.15 67.23 403.15 67.83 L 403.15 73.34 L 380 73.34 L 380 65.19 C 380 63.64 381.08 62.33 382.36 62.33 Z M 416.95 73.02 C 419.51 73.02 421.59 75.08 421.59 77.61 C 421.59 79.27 420.67 80.81 419.19 81.61 C 417.79 82.37 416.09 82.36 414.7 81.61 C 413.23 80.81 412.31 79.27 412.31 77.61 C 412.31 75.08 414.39 73.02 416.95 73.02 Z M 380 96.89 L 380 75.54 L 403.15 75.54 L 403.15 94.25 C 403.15 94.86 403.65 95.35 404.26 95.35 L 415.78 95.35 L 415.78 93.15 L 406.58 93.15 C 406.67 88.75 409.6 84.94 413.82 83.73 C 415.77 84.64 418.09 84.64 420.07 83.72 C 422.47 84.42 424.58 86.02 425.88 88.17 L 427.76 87.03 C 426.43 84.83 424.4 83.11 422.05 82.11 C 423.15 80.89 423.8 79.3 423.8 77.61 C 423.8 73.86 420.73 70.82 416.95 70.82 C 413.18 70.82 410.1 73.86 410.1 77.61 C 410.1 79.29 410.75 80.87 411.84 82.1 C 408.89 83.34 406.59 85.66 405.36 88.53 L 405.36 68.93 L 428.51 68.93 L 428.51 86.55 L 430.72 86.55 L 430.72 75.54 L 434.02 75.54 L 434.02 92.05 L 436.23 92.05 L 436.23 65.19 C 436.23 62.4 434.18 60.13 431.67 60.13 L 382.36 60.13 C 379.84 60.13 377.8 62.4 377.8 65.19 L 377.8 96.89 C 377.8 99.69 379.84 101.96 382.36 101.96 L 411.97 101.96 L 411.97 99.76 L 382.36 99.76 C 381.08 99.76 380 98.45 380 96.89 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 135,
      marginLeft: 409
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #232F3E; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(35, 47, 62)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "AWS Cognito")))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 409,
    y: 147,
    fill: "#232F3E",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "AWS Cognito")))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 530.05 283.63 L 530.05 89.05 L 454.37 89",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 530.05 288.88 L 526.55 281.88 L 530.05 283.63 L 533.55 281.88 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 449.12 89 L 456.12 85.5 L 454.37 89 L 456.12 92.5 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 186,
      marginLeft: 533
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); background-color: rgb(255, 255, 255); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 11,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      backgroundColor: "rgb(255, 255, 255)",
      whiteSpace: "nowrap"
    }
  }, "4. Checking")))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 533,
    y: 189,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "11px",
    textAnchor: "middle"
  }, "4. Checking")))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 578 329 L 713.63 329",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 718.88 329 L 711.88 332.5 L 713.63 329 L 711.88 325.5 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 329,
      marginLeft: 646
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); background-color: rgb(255, 255, 255); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 11,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      backgroundColor: "rgb(255, 255, 255)",
      whiteSpace: "nowrap"
    }
  }, "5. Request\xA0")))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 646,
    y: 333,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "11px",
    textAnchor: "middle"
  }, "5. Request\xA0")))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 500 290 L 578 290 L 578 368 L 500 368 Z",
    fill: "url(#mx-gradient-945df2-1-5a30b5-1-s-0)",
    stroke: "none",
    pointerEvents: "all"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M 532.39 346.43 L 535.66 346.43 L 535.66 344.19 L 532.39 344.19 Z M 537.89 346.43 L 541.23 346.43 L 541.23 344.19 L 537.89 344.19 Z M 524.53 300.78 L 510.05 307.97 L 510.05 352.62 L 524.53 357.52 Z M 526.75 314.99 L 526.75 344.19 L 530.09 344.19 L 530.09 346.43 L 526.75 346.43 L 526.75 359.08 C 526.75 359.44 526.58 359.78 526.29 359.99 C 526.1 360.13 525.87 360.2 525.64 360.2 C 525.52 360.2 525.4 360.18 525.29 360.14 L 508.59 354.5 C 508.13 354.34 507.83 353.91 507.83 353.43 L 507.83 307.27 C 507.83 306.84 508.07 306.45 508.45 306.26 L 525.15 297.97 C 525.49 297.8 525.9 297.82 526.23 298.03 C 526.55 298.23 526.75 298.59 526.75 298.98 L 526.75 312.75 L 530.09 312.75 L 530.09 314.99 Z M 543.45 346.43 L 546.79 346.43 L 546.79 344.19 L 543.45 344.19 Z M 543.53 314.99 L 546.79 314.99 L 546.79 312.75 L 543.53 312.75 Z M 537.96 314.99 L 541.23 314.99 L 541.23 312.75 L 537.96 312.75 Z M 532.39 314.99 L 535.66 314.99 L 535.66 312.75 L 532.39 312.75 Z M 567.95 307.97 L 553.47 300.78 L 553.47 357.52 L 567.95 352.62 Z M 570.17 353.43 C 570.17 353.91 569.87 354.34 569.41 354.5 L 552.71 360.14 C 552.6 360.18 552.48 360.2 552.36 360.2 C 552.13 360.2 551.9 360.13 551.71 359.99 C 551.42 359.78 551.25 359.44 551.25 359.08 L 551.25 346.43 L 549.09 346.43 L 549.09 344.19 L 551.25 344.19 L 551.25 314.99 L 549.09 314.99 L 549.09 312.75 L 551.25 312.75 L 551.25 298.98 C 551.25 298.59 551.45 298.23 551.77 298.03 C 552.1 297.82 552.51 297.8 552.85 297.97 L 569.55 306.26 C 569.93 306.45 570.17 306.84 570.17 307.27 Z M 542.27 322.13 L 540.19 321.33 L 534.62 335.92 L 536.7 336.73 Z M 549.81 329.26 C 550.24 328.82 550.24 328.11 549.81 327.67 L 545.35 323.18 L 543.78 324.77 L 547.45 328.47 L 543.78 332.16 L 545.35 333.75 Z M 532.65 333.75 L 528.19 329.26 C 527.76 328.82 527.76 328.11 528.19 327.67 L 532.65 323.18 L 534.22 324.77 L 530.55 328.47 L 534.22 332.16 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 375,
      marginLeft: 539
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #232F3E; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(35, 47, 62)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "API Gateway")))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 539,
    y: 387,
    fill: "#232F3E",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "API Gateway")))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M 720 348.5 L 584.37 348.5",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M 579.12 348.5 L 586.12 345 L 584.37 348.5 L 586.12 352 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 351,
      marginLeft: 650
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); background-color: rgb(255, 255, 255); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 11,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      backgroundColor: "rgb(255, 255, 255)",
      whiteSpace: "nowrap"
    }
  }, "6. Response")))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 650,
    y: 354,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "11px",
    textAnchor: "middle"
  }, "6. Response")))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M 720 290 L 798 290 L 798 368 L 720 368 Z",
    fill: "url(#mx-gradient-f78e04-1-d05c17-1-s-0)",
    stroke: "none",
    pointerEvents: "all"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M 745.67 357.97 L 731.83 357.97 L 747.13 325.99 L 754.06 340.26 Z M 748.13 322.93 C 747.94 322.55 747.55 322.3 747.13 322.3 L 747.12 322.3 C 746.69 322.3 746.3 322.55 746.12 322.94 L 729.05 358.61 C 728.89 358.95 728.91 359.36 729.11 359.68 C 729.32 360 729.68 360.2 730.06 360.2 L 746.37 360.2 C 746.8 360.2 747.2 359.95 747.38 359.56 L 756.31 340.73 C 756.46 340.43 756.46 340.07 756.31 339.77 Z M 786.88 357.97 L 773.13 357.97 L 751.08 311.81 C 750.9 311.42 750.5 311.17 750.07 311.17 L 741.08 311.17 L 741.09 300.03 L 758.72 300.03 L 780.67 346.19 C 780.85 346.58 781.25 346.83 781.68 346.83 L 786.88 346.83 Z M 788 344.6 L 782.38 344.6 L 760.43 298.44 C 760.25 298.05 759.85 297.8 759.42 297.8 L 739.97 297.8 C 739.36 297.8 738.86 298.3 738.85 298.91 L 738.84 312.28 C 738.84 312.58 738.96 312.86 739.17 313.07 C 739.38 313.28 739.66 313.4 739.96 313.4 L 749.37 313.4 L 771.42 359.56 C 771.61 359.95 772 360.2 772.43 360.2 L 788 360.2 C 788.61 360.2 789.11 359.7 789.11 359.09 L 789.11 345.71 C 789.11 345.1 788.61 344.6 788 344.6 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 375,
      marginLeft: 759
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #232F3E; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(35, 47, 62)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "Lambda functions")))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 759,
    y: 387,
    fill: "#232F3E",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Lambda functi...")))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 680,
    y: 219,
    width: 170,
    height: 20,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 229,
      marginLeft: 765
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "AWS Serverless Architecutre")))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 765,
    y: 233,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "AWS Serverless Architecutre")))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M 119 242 L 119 329.05 L 493.63 329",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M 498.88 329 L 491.88 332.5 L 493.63 329 L 491.88 325.5 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 333,
      marginLeft: 260
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); background-color: rgb(255, 255, 255); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 11,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      backgroundColor: "rgb(255, 255, 255)",
      whiteSpace: "nowrap"
    }
  }, "3. Request")))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 260,
    y: 336,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "11px",
    textAnchor: "middle"
  }, "3. Request")))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M 80 50 L 158 50 L 158 128 L 80 128 Z",
    fill: "url(#mx-gradient-f54749-1-c7131f-1-s-0)",
    stroke: "none",
    pointerEvents: "all"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M 140.81 110.79 L 118.45 67.21 L 124.85 67.21 L 147.21 110.79 Z M 150.02 111.39 L 126.52 65.59 C 126.33 65.22 125.95 64.98 125.53 64.98 L 116.63 64.98 C 116.24 64.98 115.88 65.19 115.68 65.52 C 115.48 65.85 115.46 66.26 115.64 66.61 L 139.14 112.41 C 139.33 112.78 139.72 113.02 140.13 113.02 L 149.03 113.02 C 149.42 113.02 149.78 112.81 149.98 112.48 C 150.18 112.15 150.2 111.74 150.02 111.39 Z M 127.45 110.79 L 110.34 78.7 L 113.84 72.91 L 133.84 110.79 Z M 114.89 70.13 C 114.71 69.77 114.34 69.55 113.94 69.54 C 113.56 69.51 113.17 69.73 112.96 70.07 L 108.11 78.09 C 107.91 78.43 107.89 78.85 108.08 79.19 L 125.8 112.43 C 126 112.79 126.38 113.02 126.79 113.02 L 135.68 113.02 C 136.07 113.02 136.44 112.81 136.64 112.48 C 136.84 112.14 136.85 111.73 136.67 111.38 Z M 90.94 110.79 L 106.64 84.83 L 109.83 90.82 L 102.46 103.56 C 102.26 103.9 102.26 104.33 102.46 104.67 C 102.66 105.02 103.03 105.23 103.43 105.23 L 117.52 105.23 L 120.48 110.79 Z M 119.17 103.59 C 118.97 103.23 118.59 103 118.18 103 L 105.36 103 L 112.07 91.4 C 112.26 91.07 112.27 90.66 112.09 90.32 L 107.68 82.05 C 107.49 81.7 107.13 81.48 106.73 81.47 C 106.3 81.45 105.95 81.66 105.75 82 L 88.01 111.33 C 87.81 111.67 87.8 112.1 88 112.45 C 88.19 112.8 88.56 113.02 88.97 113.02 L 122.34 113.02 C 122.73 113.02 123.09 112.81 123.29 112.48 C 123.49 112.14 123.5 111.72 123.32 111.38 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 135,
      marginLeft: 119
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #232F3E; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(35, 47, 62)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "AWS Amplify")))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 119,
    y: 147,
    fill: "#232F3E",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "AWS Amplify")))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M 158 89 L 198.05 89.05 L 360.05 90 L 363.66 89.64",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M 368.89 89.11 L 362.27 93.29 L 363.66 89.64 L 361.57 86.33 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 90,
      marginLeft: 290
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); background-color: rgb(255, 255, 255); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 11,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      backgroundColor: "rgb(255, 255, 255)",
      whiteSpace: "nowrap"
    }
  }, "1. User Auth")))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 290,
    y: 93,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "11px",
    textAnchor: "middle"
  }, "1. User Auth")))), _image || (_image = /*#__PURE__*/React.createElement("image", {
    x: 71.22,
    y: 159.5,
    width: 94.56,
    height: 82,
    xlinkHref: "data:image/png;base64,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",
    preserveAspectRatio: "none"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 98,
      height: 1,
      paddingTop: 15,
      marginLeft: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "React Font End")))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 19,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "React Font End")))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M 500 348.5 L 95.38 348.48 L 95.36 248.37",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M 95.36 243.12 L 98.86 250.12 L 95.36 248.37 L 91.86 250.12 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 348,
      marginLeft: 293
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); background-color: rgb(255, 255, 255); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 11,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      backgroundColor: "rgb(255, 255, 255)",
      whiteSpace: "nowrap"
    }
  }, "7. Response")))), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 293,
    y: 351,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "11px",
    textAnchor: "middle"
  }, "7. Response")))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M 370 108.5 L 164.37 108.5",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M 159.12 108.5 L 166.12 105 L 164.37 108.5 L 166.12 112 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 108,
      marginLeft: 291
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); background-color: rgb(255, 255, 255); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 11,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      backgroundColor: "rgb(255, 255, 255)",
      whiteSpace: "nowrap"
    }
  }, "2. Auth Token")))), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 291,
    y: 111,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "11px",
    textAnchor: "middle"
  }, "2. Auth Token"))))), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", {
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }), /*#__PURE__*/React.createElement("a", {
    transform: "translate(0,-5)",
    xlinkHref: "https://www.diagrams.net/doc/faq/svg-export-text-problems",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    fontSize: "10px",
    x: "50%",
    y: "100%"
  }, "Text is not SVG - cannot display")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmplifyArch);
export default __webpack_public_path__ + "static/media/AmplifyArch.2a41f5e2155d379849e52cceb8b286fd.svg";
export { ForwardRef as ReactComponent };